import React, { lazy, Suspense, useEffect, useState } from "react";

// Importaciones
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import useNews from "../hooks/useNews";
import usePgiModules from "../hooks/useModules";
import images from "../exports/images";
import CarouselMobile from "../components/carousel/CarouselMobile";
import CarouselMobileProdEspeciales from "../components/carousel/CarouselMobileProdEspeciales";
import ModuleBlockNews from "../components/news/ModuleBlockNews";

const NavTensoNews = lazy(() => import("../components/nav/NavTensoNews"));
const CardNews = lazy(() => import("../components/news/CardNews"));
const CardVideo = lazy(() => import("../components/news/CardVideo"));
const GrandCardBlog = lazy(() => import("../components/news/GrandCardBlog"));
const SliderNews = lazy(() => import("../pages/SliderNews"));
const BannerPub = lazy(() => import("../components/BannerPub"));

const TensoBlog = () => {
  const isTensoBlogPage = true;
  const [busqueda, setBusqueda] = useState("todos");
  const [categoriasNews, setCategoriasNews] = useState([]);
  const { news, newsVideo } = useNews();
  const [busquedaNews, setBusquedaNews] = useState([]);
  const [homeModules, setHomeModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getModulesByParams } = usePgiModules();

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });

    document.title = "Artículos Informativos sobre Ingeniería y Tecnología del hormigón";
  }, [getModulesByParams]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const handleChange = (event) => {
    const selected = event.target.defaultValue.toLowerCase();
    setBusqueda(selected);
  };
  const handleChangeSelect = (event) => {
    const selected = event.target.value.toLowerCase();
    setBusqueda(selected);
  };

  useEffect(() => {
    setBusquedaNews(news);
    const newArray = news.map((n) => (n.category ? n.category : ""));
    const unique =
      newArray?.length > 0
        ? newArray?.filter((valor, indice) => {
            return newArray?.indexOf(valor) === indice;
          })
        : null;
    setCategoriasNews(unique);
  }, [news]);

  useEffect(() => {
    if (busqueda === "todos") {
      setBusquedaNews(news);
    } else {
      const filterNews = news?.filter((n) =>
        n.category ? n.category.toLowerCase() === busqueda : ""
      );
      setBusquedaNews(filterNews);
    }
  }, [busqueda, news]);

  const newsGrandCard = news?.filter(
    (noticia) =>
      noticia?.deleted === false &&
      noticia?.visible === true &&
      noticia?.publish === true
  );

  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.open(url, "_blank");
      }
    };
    callback("event", "conversion", {
      send_to: "AW-936555276/n6xiCLOq4bYBEIzmyr4D",
    });
    return false;
  }
  return (
    <>
      <Suspense fallback={<div> </div>}>
        <NavTensoNews />
        {/* Carousel */}

        <section>
          <SliderNews />
        </section>

        {/* NOTICIAS */}
        <div className="container">
          <section id="seccion-noticias-videos-blog">
            <div className="seccion-noticias">
              {loading ? (
                <>
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                </>
              ) : (
                newsGrandCard
                  .slice(0, 3)
                  .map(
                    (noticia, index) =>
                      noticia.deleted === false &&
                      noticia.visible === true &&
                      noticia.publish === true && (
                        <GrandCardBlog
                          loading={loading}
                          key={index}
                          noticia={noticia}
                        />
                      )
                  )
              )}
            </div>
            {/* Ultimos videos y cuadrante de suscripcion */}

            <div className="seccion-videos inRight">
              <div className="text-video">
                <div className="titulo-seccion-video noticias-hr">
                  <p className="titulo-roboto">Últimos videos</p>
                </div>
                <div className="video-destacado">
                  <div id="videos-recomendados">
                    {loading ? (
                      <>
                        <CardVideo loading={loading} />
                        <CardVideo loading={loading} />
                        <CardVideo loading={loading} />
                      </>
                    ) : (
                      <>
                        {newsVideo
                          .slice(0, 3)
                          .map(
                            (noticia, index) =>
                              noticia.deleted === false &&
                              noticia.visible === true &&
                              noticia.publish === true && (
                                <CardVideo
                                  loading={loading}
                                  key={index}
                                  noticia={noticia}
                                />
                              )
                          )}
                      </>
                    )}
                  </div>
                </div>
                <div className="cuadrante-suscripcion">
                  <div>
                    <h5>Newsletter</h5>
                    <p>
                      Recibí información especializada de la industria de la
                      construcción y de Tensolite: Videos instructivos,
                      novedades del sector, grandes ofertas, y mucho más.
                    </p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button className="settings_button-pleno bg-p-secondary my-2 d-flex justify-content-center button-footer">
                      <a
                        onClick={() =>
                          gtag_report_conversion(
                            "https://mailchi.mp/tensolite/newsletters"
                          )
                        }
                        target="__blank"
                        rel="noopener"
                        href="https://mailchi.mp/tensolite/newsletters"
                      >
                        SUSCRIBIRSE
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Modulos de publicidad */}
          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Banner_publicitario":
                if (item.visible.includes("news")) {
                  return (
                    <>
                      <BannerPub
                        key={index}
                        className="w-100"
                        idProducto={"news"}
                      />
                    </>
                  );
                }
                break;
              case "Bloque_info":
                if (item.visible.includes("home")) {
                  return <ModuleBlockNews key={index} idProducto={"news"} />;
                }
                break;
              default:
            }
          })}
          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Carrousel_deLinea":
                if (item.visible.includes("news")) {
                  return (
                    <div key={index} className="producto-linea">
                      <CarouselMobile
                        isTensoBlogPage={isTensoBlogPage}
                        images={images[0]}
                      />
                    </div>
                  );
                }
                break;
              case "Carrousel_especial":
                if (item.visible.includes("news")) {
                  return (
                    <div key={index} className="producto-linea">
                      <CarouselMobileProdEspeciales
                        isTensoBlogPage={isTensoBlogPage}
                        images={images[1]}
                      />
                    </div>
                  );
                }
                break;
              default:
            }
          })}

          {/* Card Noticias */}

          <section className="container in">
            <div className="title-noticias ">
              <h3>Más noticias</h3>
              <div className="select-none mt-2 mb-3">
                <p className="mt-2 me-3 font-filter">Filtrar por: </p>
                <select
                  className="category-select"
                  name="category_news"
                  onChange={handleChangeSelect}
                >
                  <option selected>Todos</option>
                  {categoriasNews?.map(
                    (categoria, index) =>
                      categoria.length > 0 && (
                        <option id={index} value={categoria}>
                          {categoria}
                        </option>
                      )
                  )}
                </select>
              </div>
              <FormControl className="category-check">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue="todos"
                >
                  <FormControlLabel
                    value="todos"
                    control={<Radio />}
                    label="Todos"
                    onChange={handleChange}
                  />
                  {categoriasNews?.map(
                    (categoria, index) =>
                      categoria && (
                        <FormControlLabel
                          id={index}
                          value={categoria}
                          control={<Radio />}
                          label={categoria}
                          onChange={handleChange}
                        />
                      )
                  )}
                </RadioGroup>
              </FormControl>
            </div>
            <div className="slide-Tenso-News">
              <div className="slide-Tenso-detail">
                {loading ? (
                  <>
                    <CardNews loading={true} tensoblog={true} />
                    <CardNews loading={true} tensoblog={true} />
                  </>
                ) : (
                  <>
                    {busquedaNews?.map(
                      (noticia, index) =>
                        noticia?.deleted === false &&
                        noticia?.visible === true &&
                        noticia?.publish === true && (
                          <CardNews
                            key={index}
                            noticia={noticia}
                            tensoblog={true}
                            loading={loading}
                            tensoblogClass={true}
                          />
                        )
                    )}
                  </>
                )}
              </div>
            </div>
          </section>
        </div>
      </Suspense>
    </>
  );
};
export default TensoBlog;
